(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-size-filter"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.qsfReady) return;
    root.dataset.qsfReady = 'true';
    const form = root.querySelector('[data-qsf-sort]');
    if (form) {
      const select = form.querySelector('[name="sort_by"]');
      const sort = (event) => {
        event.preventDefault();
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.href);
      };
      form.addEventListener('submit', sort);
      select.addEventListener('change', sort);
      form.dataset.enhanced = 'true';
    }
    const list = root.querySelector('.quick-size-filter__list--grouped');
    const groups = root.querySelector('.quick-size-filter__groups');
    if (!list || !groups) return;
    const triggers = Array.from(groups.querySelectorAll('[data-qsf-group-trigger]'));
    const items = Array.from(list.querySelectorAll('[data-qsf-group]'));
    triggers.forEach(trigger => {
      const wrapper = document.createElement('div');
      wrapper.className = 'qsf-group';
      trigger.before(wrapper);
      wrapper.append(trigger);
    });
    list.classList.add('qsf-panel');
    const close = () => {
      triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      list.hidden = true;
    };
    const open = (trigger) => {
      const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
      close();
      if (wasOpen) return;
      trigger.closest('.qsf-group').append(list);
      list.setAttribute('aria-label', trigger.textContent.trim());
      trigger.setAttribute('aria-expanded', 'true');
      items.forEach(item => { item.hidden = item.dataset.qsfGroup !== trigger.dataset.qsfGroupTrigger; });
      list.hidden = false;
    };
    triggers.forEach(trigger => {
      const groupItems = items.filter(item => item.dataset.qsfGroup === trigger.dataset.qsfGroupTrigger);
      trigger.hidden = groupItems.length === 0;
      trigger.closest('.qsf-group').hidden = trigger.hidden;
      if (groupItems.some(item => item.querySelector('[aria-current="true"]'))) trigger.dataset.selected = 'true';
      trigger.addEventListener('click', () => open(trigger));
      trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (trigger.getAttribute('aria-expanded') !== 'true') open(trigger);
          list.querySelector('[data-qsf-group]:not([hidden]) a')?.focus();
        }
      });
    });
    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || list.hidden) return;
      const trigger = triggers.find(item => item.getAttribute('aria-expanded') === 'true');
      close();
      trigger?.focus();
    });
    groups.hidden = false;
    close();
    const selected = triggers.find(trigger => trigger.hasAttribute('data-selected'));
    if (selected) open(selected);
  };
  const initializeAll = () => document.querySelectorAll('.quick-size-filter-section').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, {once:true});
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();


  } catch(e) { console.error(e); }
})();
})();
